import { Card, CardType } from "@wingspanhq/wingspan-api-sdk";

export const selectorCardName = (card: Card) =>
  card.cardType === CardType.VIRTUAL ? "virtual card" : "physical debit card";
